import React from "react";
import Posts from "../features/posts/Posts";
export default function Home() {
  return (
    <div className=" ">
      <Posts />
    </div>
  );
}
